'use client';

import { Stepper, stepperTag } from '@ni/nimble-components/dist/esm/stepper';
import { wrap } from '../utilities/react-wrapper';

export { stepperTag };
export { type Stepper };
export const NimbleStepper = wrap(Stepper);
